import React, {useState} from 'react';
import PropTypes from 'prop-types';


import * as buttonConstants from '../buttonConstants';

import Button from '../Button';
import Captcha from '../../Security/Captcha';

import {CaptchaForm} from '../../../../services/FormService';


function CaptchaButton(props) {

    const [originalOnClick] = useState(() => props.onClick);
    const {form} = props;

    if (!form.isCaptchaRunning()) {

        return (
            <Button
                {...props}
                isDisabled={form.hasNonCaptchaErrors()}
                onClick={() => {

                    if (form.isCaptchaCompleted()) {
                        originalOnClick();
                    } else {
                        form.setIsCaptchaRunning(true);
                    }
                }}
            />
        );
    }

    return (
        <Captcha
            onError={() => form.setIsCaptchaRunning(false)}
            onStart={() => form.setIsCaptchaRunning(true)}
            onSuccess={captchaSolution => {

                form.setCaptchaSolution(captchaSolution);
                originalOnClick();
            }}
        />
    );
}


CaptchaButton.propTypes = {
    ...Button.propTypes,
    form: PropTypes.instanceOf(CaptchaForm).isRequired
};

CaptchaButton.defaultProps = {
    ...Button.defaultProps,
    flavor: buttonConstants.FLAVOR_CONFIRMATION
};


export default CaptchaButton;
